import AppBar from "@material-ui/core/AppBar";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import { makeStyles } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import {
  ARBITRATOR,
  ARBITRATOR_RV,
  DEV_WEBNYAY_URL,
  GCP_DEV_WEBNYAY_URL,
  MEDIATOR,
  SECRETARIAT,
} from "app/constants";
import FormattedMessage from "features/common/TranslatedMessage";
import DevSelectPlatform from "features/header/DevSelectPlatform";
import React, { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  isArb,
  isArbitrationConference,
  isDev,
  isDifc,
  isHotStar,
  isTiac,
  isSebi,
  isKilumaya,
  isPaytm,
  isStar,
  isMuthoot,
  isMSME,
  isOrix,
  isNalsar,
  isACCB,
} from "Routes/Routes";
import PaytmLogo from "images/paytmbank-logo.png";
import TIAC from "images/TIAC.png";
import WebnyayLogo from "images/webnyay.svg";
// Fix 1: Import from the folder (resolves via index.js) instead of the bare file
import Tiac_ProfileDropdown from "features/tiac_header_waiting/tiac_ProfileDropdown";
// Fix 2: Import the hamburger menu that is used in JSX below
import Tiac_HambergerMenu from "features/tiac_header_waiting/tiac_HamburgerMenu";
// Fix 3: Import the selector correctly — getPlatform is a selector, not a plain function
import { getPlatform } from "slices/disputeSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: TEXT.secondary,
  },
  toolbar: {
    background: "white",
    borderBottom: "1px solid #E5E5E5",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",

    "& img": {
      width: "3.5rem",
      height: "auto",
      [theme.breakpoints.down("sm")]: {
        width: "5rem",
      },
    },
  },
  // The logo and title sat flush against the top edge of the bar.
  brandLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: `${theme.spacing(2)}px`,
  },
  logoText: {
    marginLeft: theme.spacing(1.5),
    color: TEXT.primary,
    fontSize: "0.95rem",
    fontWeight: 600,
    lineHeight: 1.25,
    userSelect: "none",
    fontFamily: theme.typography.fontFamily,
  },
  difc: {
    flexGrow: 1,

    "& img": {
      width: "7rem",
      height: "auto",
      [theme.breakpoints.down("sm")]: {
        width: "6rem",
      },
    },
  },
  title1: {
    "& img": {
      width: "10rem",
      height: "auto",
      [theme.breakpoints.down("sm")]: {
        width: "7rem",
      },
    },
  },
}));

export const removeSessionStorage = () => {
  let t = localStorage.getItem("token");
  sessionStorage.clear();
  sessionStorage.setItem("token", t);
};

const AppHeader = ({ profile }) => {
  const classes = useStyles();
  let history = useHistory();
  let location = useLocation();

  const token = useSelector((state) => state.login.token);
  const profileType = useSelector(
    (state) => state.profile.profile.profile_type
  );

  // Fix 3: getPlatform is a Redux selector — call it via useSelector
  const platform = useSelector(getPlatform);

  const platformLanguages = {
    nalsar: "en,hi,bn,ta,te,mr,gu,kn,pa,ml",
  };

  useEffect(() => {
    window.platformLanguages = platformLanguages[platform];
  }, [platform]);

  const isProfessionalAccount =
    profileType === ARBITRATOR ||
    profileType === ARBITRATOR_RV ||
    profileType === MEDIATOR ||
    profileType === SECRETARIAT ||
    profileType === "guest_arbitrator";
  const loggedIn = token !== "" ? true : false;
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  let MenuItems;
  if (loggedIn) {
    MenuItems = (
      <Fragment>
        <Box className={classes.headerActions}>
          <Button
            style={{
              textTransform: "none",
              color: "black",
              fontSize: "1rem",
              fontWeight: "normal",
            }}
            onClick={() => {
              history.push("/");
              removeSessionStorage();
            }}
          >
            Dashboard
          </Button>
          <Tiac_ProfileDropdown profile={profile.profile} />
        </Box>
      </Fragment>
    );
  } else {
    // On the login screen this button only pushed "/" - the page the user is
    // already on - while using a ghost style that competed with the real Log In
    // action in the form. Show it only when logged out somewhere else.
    const onLoginScreen =
      location.pathname === "/login" || location.pathname === "/";
    MenuItems = onLoginScreen ? null : (
      <>
        <Button
          style={{
            textTransform: "none",
            color: "black",
            fontSize: "1rem",
            fontWeight: "normal",
          }}
          onClick={() => {
            history.push("/login");
          }}
        >
          <FormattedMessage id="auth.login" />
        </Button>
      </>
    );
  }

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar className={classes.toolbar} variant={"regular"}>
          <Hidden mdUp>
            <IconButton
              edge="start"
              className={classes.menuButton}
              onClick={handleDrawerOpen}
              aria-label="menu"
            >
              <MenuIcon />
            </IconButton>
          </Hidden>
          <div className={classes.title}>
            <Link to="/" className={classes.brandLink}>
              <img
                className={classes.vectorImage}
                src={"/ACCB_logo.jpg"}
                alt="Logo"
                onClick={() => {
                  removeSessionStorage();
                }}
              />
              <div className={classes.logoText}>
                Arbitration & Conciliation Centre
                <br />- Bengaluru
              </div>
            </Link>
          </div>

          {isDev &&
            ([DEV_WEBNYAY_URL, GCP_DEV_WEBNYAY_URL].includes(
              window.location.host
            ) ||
              window.location.hostname === "localhost") && (
              <DevSelectPlatform />
            )}

          <Hidden smDown>{MenuItems}</Hidden>
        </Toolbar>
      </AppBar>

      {/* Fix 2: Tiac_HambergerMenu is now properly imported above */}
      <Hidden mdUp>
        <Tiac_HambergerMenu
          open={open}
          handleDrawerClose={handleDrawerClose}
          isProfessionalAccount={isProfessionalAccount}
          profileType={profileType}
        />
      </Hidden>
    </div>
  );
};

export default AppHeader;